var React = require('react');

function VerticalSeperator (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.814 58L0 0h1.017l10.814 58-10.814 58H0l10.814-58z","fill":"#E0E3E8"}));
}

VerticalSeperator.defaultProps = {"fill":"none","viewBox":"0 0 12 116"};

module.exports = VerticalSeperator;

VerticalSeperator.default = VerticalSeperator;
